import React from 'react';
import { Building2, ArrowLeft } from 'lucide-react';

export default function PoliticaPrivacitat() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50">
      <div className="max-w-4xl mx-auto p-4 md:p-8 py-12">
        {/* Header */}
        <div className="flex justify-between items-center mb-8">
          <a
            href="/"
            className="text-gray-600 hover:text-gray-900 flex items-center gap-2 font-medium"
          >
            <ArrowLeft className="w-4 h-4" />
            Tornar
          </a>
          <div className="flex items-center gap-2">
            <img src="/logo.png" alt="Fercamp" className="h-8 object-contain" />
          </div>
        </div>

        {/* Contingut */}
        <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12">
          <h1 className="text-4xl font-bold mb-2" style={{ color: '#97312b' }}>
            Política de Privacitat
          </h1>
          <p className="text-sm text-gray-500 mb-8">Última actualització: Octubre 2025</p>

          <div className="space-y-6 text-gray-700 leading-relaxed">
            {/* INTRODUCCIÓ */}
            <section>
              <p>
                En compliment de la <strong>Llei qualificada 15/2003, del 18 de desembre, de protecció de dades personals</strong> 
                del Principat d'Andorra i del <strong>Reglament (UE) 2016/679 del Parlament Europeu (RGPD)</strong>, 
                Fercamp Immobiliària informa els usuaris sobre la seva política de protecció de dades de caràcter personal.
              </p>
            </section>

            {/* 1. RESPONSABLE */}
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">1. Responsable del tractament</h2>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li><strong>Responsable:</strong> Fercamp Immobiliària</li>
                <li><strong>Adreça:</strong> Andorra</li>
                <li><strong>Correu electrònic:</strong> fercamp@andorra.ad</li>
                <li><strong>Telèfon:</strong> +376 738 721</li>
              </ul>
            </section>

            {/* 2. DADES RECOLLIDES */}
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">2. Dades personals que recollim</h2>
              <p>A través del simulador i els formularis de contacte, podem recollir les següents dades:</p>
              <ul className="list-disc list-inside mt-3 space-y-2 ml-4">
                <li>Nom i cognoms</li>
                <li>Correu electrònic</li>
                <li>Telèfon de contacte</li>
                <li>Dades econòmiques (ingressos mensuals, import del préstec)</li>
                <li>Dades del simulador (edat, termini, preferències d'habitatge)</li>
                <li>Adreça IP i dades de navegació (cookies)</li>
              </ul>
            </section>

            {/* 3. FINALITAT */}
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">3. Finalitat del tractament</h2>
              <p>Les dades personals recollides seran tractades amb les següents finalitats:</p>
              <ul className="list-disc list-inside mt-3 space-y-2 ml-4">
                <li>Proporcionar els serveis del simulador d'hipoteques</li>
                <li>Contactar amb l'usuari per oferir informació sobre habitatges</li>
                <li>Enviar informació sobre el programa d'habitatge del Govern quan entri en vigor</li>
                <li>Gestionar consultes i sol·licituds</li>
                <li>Millorar els nostres serveis i el funcionament del web</li>
                <li>Complir amb obligacions legals</li>
              </ul>
            </section>

            {/* 4. LEGITIMACIÓ */}
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">4. Legitimació</h2>
              <p>La base legal per al tractament de les vostres dades és:</p>
              <ul className="list-disc list-inside mt-3 space-y-2 ml-4">
                <li><strong>Consentiment de l'interessat:</strong> En omplir els formularis i acceptar la política de privacitat</li>
                <li><strong>Execució d'un contracte:</strong> Per proporcionar els serveis sol·licitats</li>
                <li><strong>Interès legítim:</strong> Per millorar els nostres serveis</li>
              </ul>
            </section>

            {/* 5. CONSERVACIÓ */}
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">5. Conservació de les dades</h2>
              <p>
                Les dades personals seran conservades mentre siguin necessàries per a les finalitats descrites o mentre no 
                sol·liciteu la seva supressió. En qualsevol cas, les dades es conservaran durant els terminis legalment establerts.
              </p>
              <p className="mt-3">
                <strong>Termini màxim de conservació:</strong> 5 anys des de l'última interacció, excepte obligacions legals que requereixin períodes més llargs.
              </p>
            </section>

            {/* 6. DESTINATARIS */}
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">6. Destinataris de les dades</h2>
              <p>Les vostres dades poden ser comunicades als següents destinataris:</p>
              <ul className="list-disc list-inside mt-3 space-y-2 ml-4">
                <li>Proveïdors de serveis tecnològics (hosting, email, CRM)</li>
              </ul>
              <p className="mt-3">
                <strong>No cedim les vostres dades a tercers</strong> amb finalitats comercials sense el vostre consentiment exprés.
              </p>
            </section>

            {/* 7. DRETS */}
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">7. Drets dels usuaris</h2>
              <p>Teniu dret a:</p>
              <ul className="list-disc list-inside mt-3 space-y-2 ml-4">
                <li><strong>Accés:</strong> Conèixer quines dades tenim sobre vosaltres</li>
                <li><strong>Rectificació:</strong> Corregir dades inexactes o incompletes</li>
                <li><strong>Supressió:</strong> Sol·licitar l'eliminació de les vostres dades</li>
                <li><strong>Oposició:</strong> Oposar-vos al tractament de les vostres dades</li>
                <li><strong>Limitació:</strong> Limitar el tractament de les vostres dades</li>
                <li><strong>Portabilitat:</strong> Rebre les vostres dades en format estructurat</li>
                <li><strong>Retirar el consentiment:</strong> En qualsevol moment</li>
              </ul>
              <p className="mt-4">
                Per exercir aquests drets, podeu contactar-nos a:
              </p>
              <ul className="list-none mt-2 space-y-1 ml-4">
                <li>📧 <a href="mailto:fercamp@andorra.ad" className="font-semibold hover:underline" style={{ color: '#97312b' }}>fercamp@andorra.ad</a></li>
                <li>📞 <a href="tel:+376738721" className="font-semibold hover:underline" style={{ color: '#97312b' }}>+376 738 721</a></li>
              </ul>
            </section>

            {/* 8. SEGURETAT */}
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">8. Seguretat de les dades</h2>
              <p>
                Fercamp aplica mesures tècniques i organitzatives adequades per garantir la seguretat de les dades personals 
                i evitar la seva alteració, pèrdua, tractament o accés no autoritzat.
              </p>
              <p className="mt-3">
                Les dades es transmeten mitjançant protocols segurs (HTTPS/SSL) i s'emmagatzemen en servidors amb mesures 
                de seguretat actualitzades.
              </p>
            </section>

            {/* 9. COOKIES
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">9. Cookies</h2>
              <p>
                Aquest lloc web utilitza cookies tècniques necessàries per al seu funcionament. Podeu obtenir més informació 
                a la nostra <a href="/politica-cookies" className="font-semibold underline" style={{ color: '#97312b' }}>Política de Cookies</a>.
              </p>
            </section> */}

            {/* 10. MODIFICACIONS */}
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">9. Modificacions</h2>
              <p>
                Fercamp es reserva el dret a modificar aquesta política de privacitat per adaptar-la a canvis legislatius o 
                jurisprudencials. En cas de modificacions substancials, se n'informarà als usuaris.
              </p>
            </section>


            {/* CONTACTE */}
            <section className="mt-8 p-6 bg-green-50 rounded-xl border-2 border-green-200">
              <h3 className="text-xl font-bold text-gray-900 mb-3">Contacte</h3>
              <p>
                Per a qualsevol dubte sobre aquesta política de privacitat o l'exercici dels vostres drets:
              </p>
              <ul className="list-none mt-3 space-y-2">
                <li>📧 <a href="mailto:fercamp@andorra.ad" className="font-semibold hover:underline" style={{ color: '#97312b' }}>fercamp@andorra.ad</a></li>
                <li>📞 <a href="tel:+376738721" className="font-semibold hover:underline" style={{ color: '#97312b' }}>+376 738 721</a></li>
              </ul>
            </section>
          </div>
        </div>

        {/* Footer mini */}
        <div className="text-center mt-8">
          <a
            href="/"
            className="text-sm text-gray-600 hover:text-gray-900 underline"
          >
            Tornar al simulador
          </a>
        </div>
      </div>
    </div>
  );
}